module.exports = __webpack_public_path__ + "static/media/20171027_183636.d59f390e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20171027_183636.jpg
// module id = 474
// module chunks = 0